<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
import PopupComponent from "./components/resources/PopupComponent.vue";
export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
    PopupComponent,
  },
  data() {
    return {
      site: 29,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template>
  <!-- <CardGridComponent
    titulo="Departamentos"
    :data="[
      {
        target: '_self',
        title: 'Sueldos',
        url: '?uid=07RFVBKYUJ',
      },
      {
        target: '_self',
        title: 'Interoperabilidad',
        url: '?uid=Z8TYJOD6N8',
      },
      {
        target: '_self',
        title: 'Sistemas',
        url: '?uid=1NOGCE868W',
      },
      {
        target: '_self',
        title: 'Soporte',
        url: '?uid=FCXTJVXLA2',
      },
    ]"
    columnas="4"
  /> -->

  <!-- seccion info institucional -->
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="pb-3">Institucional</h2>
          <h3 class="pb-3">Dirección Provincial de Informática.</h3>
          <h3 class="link-secondary text-ptn-color-gsj-brand">Visión:</h3>
          <p>
            Ser el referente tecnológico del Gobierno de la Provincia de San
            Juan, aportando innovación continua, aplicando metodologías de
            trabajo, velando por la sustentabilidad de nuestros equipos,
            persiguiendo la transversalidad, transparencia, productividad y
            compromiso.
          </p>
          <h3 class="link-secondary text-ptn-color-gsj-brand">Misión:</h3>
          <p class="pb-3">
            Proporcionar a los organismos del Poder Ejecutivo de San Juan,
            servicios tecnológicos de calidad, brindando herramientas, sistemas
            informáticos, integraciones, soporte y asistencia, contribuyendo
            activamente a la modernización del Estado.
          </p>
          <h3 class="link-secondary text-ptn-color-gsj-brand">
            Responsabilidades:
          </h3>
          <div>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Analizar, diseñar, desarrollar y mantener sistemas informáticos
              transversales y verticales.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Integración e interoperabilidad de sistemas.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Brindar soporte técnico y funcional.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Liquidar los sueldos del Poder Ejecutivo, Legislativo, Judicial y
              Municipios.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Asistencia técnica en adquisición o arrendamiento de bienes y
              servicios de carácter informático.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!----Fin sección institucional---->

  <BoxIconGridComponent :columnas="5" titulo="Servicios y Trámites" :data="[
    {
      desc: null,
      icon: 'ptn-i-centro-civ',
      target: '_blank',
      title: 'Gestión de Información y Procesos con Entidades y Reparticiones',
      url: 'https://gestiondpi.sanjuan.gob.ar/',
    },
        {
      desc: null,
      icon: 'ptn-i-centro-civ',
      target: '_self',
      title: 'Sistemas',
      url: '?uid=CUMV-VIEW-BoxIconGridComponent',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Catálogo de Aplicaciones y Servicios',
    url: '?uid=CUMV-CatalogodeAplicacionesyServicios',
  },
  {
    desc: null,
    icon: 'ptn-i-documento',
    target: '_blank',
    title: 'Estándares para Proveedores de Software',
    url: 'https://dpi.sanjuan.gob.ar/archivos/EstándaresparaProveedoresdeSoftware20210610.pdf',
  }
  ]" />

  <popup-component :columnas="3" titulo="" iconos-grandes="false" :index="14" :data="[
    {
      desc: null,
      icon: 'ptn-i-hacienda-f',
      target: '_blank',
      title: 'Trámite de sueldos',
      contenido: `Consiste en informar las novedades a través de cidi para poder efectuarlo haga click acá <a href='https://cidi.sanjuan.gob.ar/'> https://cidi.sanjuan.gob.ar/</a>`,
    },
    {
      desc: null,
      icon: 'ptn-i-centro-civ',
      target: '_blank',
      title: 'Formulario 101',
      contenido: `Formulario para solicitar el acceso a un sistema, modificación de usuario o baja de perfil, para poder completarlo haga click acá <a href='https://cidi.sanjuan.gob.ar/'>https://cidi.sanjuan.gob.ar/</a>`,
    },
  ]" />
  <NewsComponent />

  <ITCGridComponent :columnas="4" titulo="Consultas y Trámites" :data="[
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Consulta de Expedientes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent',
    },
    {
      desc: null,
      icon: 'ptn-i-acuerdo',
      target: '_blank',
      title: 'Contrataciones',
      url: 'https://compraspublicas.sanjuan.gob.ar/',
    },
    {
      desc: null,
      icon: 'note',
      target: '_self',
      title: 'Trámites',
      url: 'https://tramite.sanjuan.gob.ar/principal/listar',
    },
    {
      desc: null,
      icon: 'forum',
      target: '_self',
      title: 'Consultas y Solicitudes',
      url: '?uid=CUMV-VIEW-FormComponent',
    },
  ]" />

  <GridLinkComponent :columnas="4" titulo="Links Útiles" :data="[
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Ministerio de Economía, Hacienda y Finanzas',
      url: 'https://hacienda.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title:
        'Secretaría de Transformación Digital y Modernización del Estado',
    url: 'https://sgp.sanjuan.gob.ar/',
  },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Dirección de Gobierno Digital',
      url: 'https://gobiernodigital.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Dirección de Ciberseguridad',
      url: 'https://ciberseguridad.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title:
        'Dirección de Recursos Humanos y Organización del Empleo Público',
      url: 'https://rrhh.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'IIEE - Instituto de Investigaciones Económicas y Estadísticas',
      url: 'https://web.sanjuan.gob.ar/iiee/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Ciudadano Digital',
      url: 'https://cidi.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Innova',
      url: 'http://innova.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Compras Públicas',
      url: 'https://compraspublicas.sanjuan.gob.ar/',
    },
  ]" />

  <!--  
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <DocumentListComponent
          resultados="5"
          :show-fecha="false"
          titulo="Guía de Trámites"
          :filtros="{ site: this.site }"
        />
      </div>
      <div class="col-md-6">
        <DocumentListComponent
          resultados="5"
          :show-fecha="true"
          titulo="Licitaciones"
          :filtros="{ site: 4 }"
        />
      </div>
    </div>
  </div>

  
-->
</template>
